import styled from 'styled-components';

import { colors, metrics } from '@/theme';

const { headerHeight } = metrics;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: ${colors.white};
  padding: ${headerHeight.desktop}px 85px 80px 85px;
  box-sizing: border-box;
  opacity: ${() => (typeof window === 'undefined' ? 0 : 1)};
  @media (max-width: ${metrics.mobile}px) {
    padding: ${metrics.headerHeight.mobile}px 25px 25px 25px;
  }
  max-width: 1440px;
  min-width: 350px;
  margin: auto;
`;

export const Main = styled.main`
  flex: 1 1 auto;
  min-height: ${({ isOpenMenu }) => (isOpenMenu
    ? '628px'
    : `calc(100vh - ${metrics.headerHeight.mobile}px - ${metrics.footerHeight.desktop}px - 195px - 80px)`)
};
  transition: min-height .4s;
  @media (max-width: ${metrics.mobile}px) {
    min-height: auto;
  }
`;
